import { Component, Input, ViewChild } from '@angular/core';
import { UserService } from '@user';
import { UpgradeService } from './upgrade.service';
import { MessagesComponent, MessagesService, MessageType } from '@ui-messages';
import { PlantService } from '@plants';
import { __i18n } from '@localisation';
import { ButtonStates, ClxButtonComponent } from '@forms/clx-forms/controls/clx.button.component';

@Component({
    selector: 'upgrade-configuration',
    templateUrl: './upgrade-configuration.template.html',
    standalone: false
})
export class UpgradeConfigurationComponent {
    constructor(
        public user: UserService,
        public upgradeService: UpgradeService,
        public messageService: MessagesService,
        public plantService: PlantService
    ){
        this.notify = user.getUser().username || '';
    }

    public notify: string;

    @ViewChild('parameter', { static : false })
    public parameterFile: any;

    @ViewChild('bacnetParameter', { static : false })
    public bacnetParameterFile: any;

    @ViewChild('mapping', { static : false })
    public mappingFile: any;

    @ViewChild('savebutton', { static : false })
    public saveButton: ClxButtonComponent;

    public innerResource: any;

    @Input()
    public set resource(resource: any){
        this.innerResource = resource;
        if(resource?.objectHandlerMappingFileNames?.length){
            this.showMappingFile = true;
        }
    }

    public get resource(){
        return this.innerResource;
    }

    public isVisible: boolean = false;

    public showMappingFile: boolean = false;

    public currentDate() {
        return this.now;
    }

    public async send(data){
        this.saveButton.state = ButtonStates.loading;
        this.saveButton.disabled = true;
        const parameter = (this.parameterFile) ? this.parameterFile.getSelectedEntry() : null;
        const bacnetParameterFile = (this.bacnetParameterFile) ? this.bacnetParameterFile.getSelectedEntry() : null;
        const mappingFile = (this.mappingFile) ? this.mappingFile.getSelectedEntry() : null;
        const output = {
            startTime : this.now,
            scopeConfigFileName : null,
            fileDownloadTimeout : data.FileDownloadTimeout,
            applicationShutdownTimeout : data.ApplicationShutdownTimeout,
            retryCount : data.RetryCount,
            notificationRecipients : data.NotificationRecipients,
            parameterFileName : (parameter && (parameter.SiteFileId || parameter.id))
                ? parameter.SiteFileId || parameter.id
                : null,
            bacnetFileName : (bacnetParameterFile && (bacnetParameterFile.SiteFileId || bacnetParameterFile.id))
                ? bacnetParameterFile.SiteFileId || bacnetParameterFile.id
                : null,
            mappingFileName : (mappingFile && mappingFile.SiteFileId)
                ? mappingFile.SiteFileId
                : null,
            comment : data.Comment
        };

        const result = await this.upgradeService.startUpgrade(output);
        if(result.status === 4) {
            this.messageService.addMessage({
                text : result.message,
                type : MessageType.error
            });
        }

        const currentPlant = await this.plantService.getCurrentPlant();
        this.messageService.addMessage({
            type : MessageType.success,
            text : __i18n('Upgrade process for plant [plantName] scheduled.', 'upgrade.task.scheduled.message').replace('[plantName]', currentPlant.name)
        });
        this.close();
        this.saveButton.state = null;
        this.saveButton.disabled = null;
    }

    public now: number = Date.now();

    public initValue : number;

    public open(){
        this.isVisible = true;
        this.now = Date.now();

    }

    public close(){
        this.isVisible = false;
    }
}
